import '../../../common/dashboard/filters/filtersFactory.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.FiltersFactory extends Common.Dashboard.Filters.FiltersFactory

  FILTERS = CustomerVisualMode.Filters

  constructor: ({groups, subtypes, advisors, teams, ticketAttributeDefinitions, isReadOnly = false}) ->
    @_filters = @_createFiltersDataObject(
      groups,
      subtypes,
      advisors,
      teams,
      ticketAttributeDefinitions,
      isReadOnly
    )

  _createFiltersDataObject: (groups, subtypes, advisors, teams, ticketAttributeDefinitions, isReadOnly) ->
    APPLIED = FILTERS.Applied
    UNAPPLIED = FILTERS.Unapplied
    {
      "#{FILTERS.DateFilter.FILTER_TYPE}":
        filter: (contents) -> new FILTERS.DateFilter(values: contents)
        applied: (filter) -> new APPLIED.AppliedDateFilterView({filter, isReadOnly})
        unapplied: (filter) -> new UNAPPLIED.UnappliedDateFilterView({filter})
      "#{FILTERS.GroupsFilter.FILTER_TYPE}":
        filter: (contents) -> new FILTERS.GroupsFilter(values: contents)
        applied: (filter) -> new APPLIED.AppliedGroupsFilterView({filter, groups, isReadOnly})
        unapplied: (filter) -> new UNAPPLIED.UnappliedGroupsFilterView({filter, groups})
      "#{FILTERS.SubTypeFilter.FILTER_TYPE}":
        filter: (contents) -> new FILTERS.SubTypeFilter(values: contents)
        applied: (filter) -> new APPLIED.AppliedSubTypeFilterView({filter, subtypes, isReadOnly})
        unapplied: (filter) -> new UNAPPLIED.UnappliedSubTypeFilterView({filter, subtypes})
      "#{FILTERS.StatusFilter.FILTER_TYPE}":
        filter: (contents) -> new FILTERS.StatusFilter(values: contents)
        applied: (filter) -> new APPLIED.AppliedStatusFilterView({filter, isReadOnly})
        unapplied: (filter) -> new UNAPPLIED.UnappliedStatusFilterView({filter})
      "#{FILTERS.AssignedAdvisorFilter.FILTER_TYPE}":
        filter: (contents) -> new FILTERS.AssignedAdvisorFilter(values: contents)
        applied: (filter) -> new APPLIED.AppliedAssignedAdvisorFilterView({filter, advisors, isReadOnly})
        unapplied: (filter) -> new UNAPPLIED.UnappliedAssignedAdvisorFilterView({filter, advisors})
      "#{FILTERS.UsersGroupFilter.FILTER_TYPE}":
        filter: (contents) -> new FILTERS.UsersGroupFilter(values: contents)
        applied: (filter) -> new APPLIED.AppliedUsersGroupFilterView({filter, teams, isReadOnly})
        unapplied: (filter) -> new UNAPPLIED.UnappliedUsersGroupFilterView({filter, teams})
      "#{FILTERS.TicketAttributesFilter.FILTER_TYPE}":
        filter: (contents) -> new FILTERS.TicketAttributesFilter
          values: contents
          possibleValues: ticketAttributeDefinitions
        applied: (filter) -> new APPLIED.AppliedTicketAttributesFiltersView({filter, ticketAttributeDefinitions,
          isReadOnly})
        unapplied: (filter) -> new UNAPPLIED.UnappliedTicketAttributesFiltersView({filter, ticketAttributeDefinitions})
    }

  _getFilterData: (filterType) ->
    filtersTypes = [FILTERS.FixedStringAttributeFilter.FILTER_TYPE, FILTERS.HierarchicalTagsAttributeFilter.FILTER_TYPE]
    filterType = FILTERS.TicketAttributesFilter.FILTER_TYPE if filtersTypes.includes(filterType)
    super(filterType)
